import SavedViewDialog from './saved_view_dialog'

export default SavedViewDialog;
